export function isWebSoundPermissionAllowed(): boolean {
    if (!window.AudioContext) return false;
    const context = new AudioContext();
    return context.state === 'running';
}
